import React from 'react';
import PublicPage from '../cms/PublicPage';

export default function HomePage() {
  return <PublicPage slug="home" />;
}
